import { Head } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { SiteForm, type SiteData } from "./SiteForm"

const BLANK_SITE: SiteData = {
  position: 0,
  name: "",
  slug: "",
  region: "",
  address: "",
  maps_url: "",
  // A new location has no map pin until someone looks one up.
  latitude: null,
  longitude: null,
  opening_hours: "",
  features: [],
  description_en: "",
  description_es: "",
  status: "active",
}

export default function LocationNew() {
  return (
    <AdminShell>
      <Head title="Website Pages — New location">
        <meta
          name="description"
          content="Add a new Sanctuary Therapy Centre location to the website."
        />
        <meta property="og:title" content="Website Pages — New location" />
        <meta
          property="og:description"
          content="Add a new Sanctuary Therapy Centre location to the website."
        />
      </Head>

      <Breadcrumbs
        items={[{ label: "Website Pages", href: "/admin/website" }, { label: "New location" }]}
      />

      <PageHeader
        title="New location"
        description="Start with the location details — rooms, page content, and photos come next."
      />

      <div className="mt-6 max-w-2xl">
        <SiteForm site={BLANK_SITE} actionUrl="/admin/website/locations" method="post" />
      </div>
    </AdminShell>
  )
}
